import { render, staticRenderFns } from "./EditAddressModal.vue?vue&type=template&id=19867708&lang=pug"
import script from "./EditAddressModal.vue?vue&type=script&lang=js"
export * from "./EditAddressModal.vue?vue&type=script&lang=js"
import style0 from "./EditAddressModal.vue?vue&type=style&index=0&id=19867708&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports